/**
 * Session keep-alive constants for the console SPA
 * (specs/20260916-cortex-console-session-keep-alive design.md section 4).
 *
 * Values are copied from the product SPA (axiosConfig.ts / msalSilentRecovery.ts), not
 * imported: the console bundle must not depend on the product module graph.
 */

/** Treat an ID token as stale this long before its ``exp`` (product ``SKEW_MS``). */
export const CONSOLE_TOKEN_SKEW_MS = 5 * 60 * 1000;

/** Keep-alive tick when the last renewal succeeded (product ``KEEP_ALIVE_BASE_MS``). */
export const CONSOLE_KEEP_ALIVE_BASE_MS = 5 * 60 * 1000;

/** Longest the keep-alive backs off to after repeated failures. */
export const CONSOLE_KEEP_ALIVE_MAX_BACKOFF_MS = 30 * 60 * 1000;

/** Bounded silent retries for iframe / interaction-required flake (product D37). */
export const CONSOLE_SILENT_ACQUIRE_MAX_ATTEMPTS = 3;
export const CONSOLE_SILENT_ACQUIRE_BASE_DELAY_MS = 400;

/**
 * The one console API refusal a fresh token can fix
 * (cortex_console_token_validator.REASON_EXPIRED_TOKEN). Every other ``blocked``
 * reason is non-renewable and keeps today's release-and-sign-in path.
 */
export const CONSOLE_RENEWABLE_REFUSAL_REASON = "blocked_expired_token";
